import { render } from "./Register.vue?vue&type=template&id=5e7b0034&scoped=true&ts=true&lang=pug"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=5e7b0034&scoped=true&lang=css"
import "./Register.vue?vue&type=style&index=1&id=5e7b0034&lang=css"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7b0034"]])

export default __exports__